import React from 'react';
import Lottie from 'lottie-react';
import {connect} from 'react-redux';

import maxisLoader from '../../assets/lotties/maxis_loader.json';

const LoadingText = React.memo(({text, previousText}) => {
    return (
        <>
            {text && (
                <div className='loader-text-box'>
                    <div className='loader-text outer text-frog-green maxis-bold fs-20 lh-25 mb-2'>{previousText}</div>
                </div>
            )}
            {text && (
                <div className='loader-text-box'>
                    <div className='loader-text inner text-frog-green maxis-bold fs-20 lh-25 mb-2'>{text}</div>
                </div>
            )}
        </>
    );
});

function LoaderSpinner(props) {
    const flag = props.forcedVisibility || (props.loader && props.loader.isLoading) || false;
    return (
        <div className={flag ? `loader-container${props.loader.text ? ' have-text' : ''}` : ''}>
            {flag ? (
                <>
                    <div className={`lottie-gif ${props.loader.text ? 'have-text' : ''}`}>
                        <Lottie animationData={maxisLoader} loop />
                    </div>
                    <LoadingText text={props.loader.text} previousText={props.loader.previousText} />
                </>
            ) : (
                ''
            )}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loader: state.loader
    };
};
export default connect(mapStateToProps, null)(LoaderSpinner);
